import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ReferenceField,
  DateField,
  ShowButton,
} from "react-admin";

const WebhookEventsList = ({ filter }) => {
  return (
    <List
      title=" "
      hasEdit={false}
      hasList={false}
      hasCreate={false}
      hasShow={false}
      filter={filter}
      basePath={"/webhookevents"}
      resource="webhookevents"
      component={"div"}
    >
      <Datagrid>
        <ReferenceField
          label="Zone"
          source="zone_id"
          reference="zones"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          label="Camera"
          source="camera_id"
          reference="cameras"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField label="Event Type" source="event_type" />
        <DateField label="Created At" source="createdAt" />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default WebhookEventsList;
